var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-btn',{staticClass:"text-none pr-4",attrs:{"flat":"","color":"#004884"},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v("arrow_back")]),_vm._v("\n    "+_vm._s(_vm._f("translate")('BUTT_NAV_BACK'))+"\n  ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f03c7f50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/BtnBack.vue
// module id = null
// module chunks = 